import { createBrowserRouter } from "react-router-dom";
import Home from "./routes/Home";
import Root from "./components/Root";
import NotFound from "./routes/NotFound";
import Works from "./routes/Works";
import About from "./routes/About";
import Articles from "./routes/Articles";
import WorkDetail from "./routes/WorkDetail";
import ArticleDetail from "./routes/ArticleDetail";
import Tests from "./routes/Tests";
import ArchiLawModel from "./routes/ArchiLawModel";
import NemoView from "./routes/NemoView";
import KakaoMap from "./routes/MapView";
import Architon from "./routes/Architon";
// import SizeCreate from "./routes/test_ongoing/SizeCreate";
// import SizeView from "./routes/test_ongoing/SizeView";
// import SizeDetail from "./routes/test_ongoing/SizeDetail";
import Education from "./routes/Education";
import EducationDetail from "./routes/EducationDetail";
const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <NotFound />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "works",
        element: <Works />,
      },
      {
        path: "works/:workId",
        element: <WorkDetail />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "articles",
        element: <Articles />,
      },
      {
        path: "articles/:articleId",
        element: <ArticleDetail />,
      },
      {
        path: "tests",
        element: <Tests />,
      },
      {
        path: "tests/archiLawModel",
        element: <ArchiLawModel />,
      },
      {
        path: "tests/nemo",
        element: <NemoView />,
      },
      {
        path: "architon",
        element: <Architon />,
      },
      {
        path: "education",
        element: <Education />,
      },
      {
        path: "education/:educationId",
        element: <EducationDetail />,
      },
      {
        path: "map",
        element: <KakaoMap />,
      },
    ],
  },
]);
export default router;
